export default __webpack_public_path__ + "navigation-examples-basic-thumbnail-v1-960-767ac989c1505d0a0daf141ece989ce0.webp";